import React, { Component } from "react";
import ContactComponent from './components/ContactComponent';
import "./../Home/assets/css/fontawesome.css";
import "./../Home/assets/css/templatemo-finance-business.css";
import "./../Home/assets/css/owl.css";


export class ContactContainer extends Component {
    constructor (props){
        super(props)
        this.state = {
            // set any states we need for the Contact page
        }
    }

    render(){
        return(
            <ContactComponent/>
        )
    }
          
        
}

ContactContainer.defaultProps={

}
ContactContainer.propTypes = {

}

export default(ContactContainer);